export default __webpack_public_path__ + "static/media/kovalam.732619b2.jpg";